export default "__VITE_ASSET__v7hAG5h0__"